import { DisplayService } from "@app/services/display.service";
import { VeriDate } from "@app/services/veriDate.service";
import { IVeriMapComponent, MapPopupType } from "@directives/_map/veriMap/veriMapComponent/veriMap.component";
import { IUtilisationMetrics } from "@directives/_map/veriMap/veriMapVehicles/veriMapVehicles.component";
import { EventAction } from "@directives/_vehicle/journeySummary/journeySummary.component";
import { LiveMapOrderByOptions } from "@directives/_vehicle/vehicleList/vehicleList.component";
import { BroadcastEvent } from "@enums/BroadcastEvent";
import { AccountFeatures } from "@enums/account/AccountFeature";
import { IGeofence } from "@interfaces/IGeofences";
import { IGoogleMapsMarker } from "@interfaces/IGoogleMapsMarkerOptions";
import { IJourney, IJourneyModel } from "@interfaces/IJourney";
import { IPlot, IPlotEvent } from "@interfaces/IPlot";
import { ISensorData } from "@interfaces/ISensorData";
import { IVehicle } from "@interfaces/IVehicle";
import { IVehicleDriverMapping } from "@interfaces/IVehicleDriverMapping";
import { IVehicleTrailerMapping } from "@interfaces/IVehicleTrailerMapping";
import { AccountFeatureService, UserRole } from "@services/accountFeature.service";
import { AccountOption } from "@services/class/AccountOption";
import { DriverAssignmentService } from "@services/driverAssignment.service";
import { IHistoricalDay, JourneyService } from "@services/journey.service";
import { NavigationService } from "@services/navigation.service";
import { PlotService } from "@services/plot.service";
import { PreferencesService } from "@services/preferences.service";
import { SessionService } from "@services/session.service";
import { TranslationService } from "@services/translation.service";
import { VehicleService } from "@services/vehicle.service";
import { WebSocketService } from "@services/websocket.service";
import { NgMapCluster } from "@typings/google.maps.angular";
import { StateService } from "@uirouter/angularjs";
import { CameraDisplayService } from "@videos/cameraDisplay.service";
import * as angular from "angular";
import * as moment from "moment";
import { SettingsName } from "../../../class/SettingsName";
import { IVideoEntry } from "../videos/models/IVideoEntry";
import { IVideoPlaybackEvent } from "../videos/models/IVideoPlaybackEvent";
import { ITimelineClickData } from "./components/vehicleTimeline.component";
import { IJourneyGraphExtremes } from "./journeys/journeyGraph.component";
import "./livemap.scss";
import { VehicleHistoryPage } from "./sideNav/vehicleHistory.component";
import { AccountSettingsService, IAccountSettingsContent } from "../../../services/account-settings.service";
import { FleetNavigationModule } from "@app/main/modules/fleet/fleet.navigation";
import { CalendarDirection } from "@app/enum/CalendarDirection.enum";
import { tap, catchError, of, finalize, Observable, Subscription } from "rxjs";

interface ILivemapTab {
    label: string;
    tab: LiveMapPageStates;
    //tabName: string;
    disabled: boolean;
    disabledFunc: () => boolean;
    urlSlug?: string;
}

enum LiveMapPageStates {
    Live,
    History,
    Graph,
    Video,
    Timeline
}

export class LiveMapController {
    // Dates
    selectedPlotDate = new Date();

    // Vehicle selections
    vehicles: IVehicle[] = [];
    vehiclesDisplay: IVehicle[] = []; // Cached list used for display purposes only
    //selectedPlotIndex = 0;

    selectedVehicle: IVehicle = null;
    highlightedVehicle: IVehicle;
    vehicleUpdateInterval: angular.IPromise<any>;
    utilisationMetrics: IUtilisationMetrics;

    // Journey selections
    historicalDay: IHistoricalDay;
    journeyModel: IJourneyModel;
    currentJourney: IJourney;
    //highlightedJourney: IJourney;

    journeyExtremes: IJourneyGraphExtremes;
    journeyEvents: IPlotEvent[] = [];

    // Plots
    initialLoading = true;
    loadingHistory = false;
    plots: IPlot[] = [];
    displayPlots: IPlot[] = [];

    latestPlotUpdateTime: moment.Moment;
    latestRedForgeCanParams: ISensorData;
    lastScreenRefreshTime: moment.Moment;

    selectedPlotEvent: IPlotEvent;
    highlightedPlotEvent: IPlotEvent;

    loadingHistoryPromise: angular.IPromise<any>;
    //journeyPlot: IPlot;

    historicalDriverTime: moment.Moment;

    showMapCross = false;
    nearestToCenter: google.maps.LatLng;

    fitMap = true;
    veriMap: IVeriMapComponent;
    updateMapSize: any;
    vehicleHistoryPage: VehicleHistoryPage;

    selectedPlot: IPlot;
    highlightedPlot: IPlot;
    highlightedPlotIndex: number; // probably not needed

    expectedVideoLocation: IPlotEvent;

    requestVideoTime: moment.Moment;

    selectedJourney: IJourney;
    highlightedJourney: IJourney;

    timelineClickData: ITimelineClickData;

    start: Date;
    end: Date;

    showLiveView = true;
    showHistoryView: boolean;
    showGraphView: boolean;
    showVideoView: boolean;
    showLocationsView: boolean;
    showTimelineView: boolean;
    bottomPanelHeight: number;
    loadingBottomPanelContents: boolean;

    livemapTabs: ILivemapTab[] = [];
    selectedTab: ILivemapTab;

    accountOptions: AccountOption;
    popupPosition: google.maps.LatLng;
    popupModel: any;

    showVehiclesNotTracking: boolean;

    canManageGeofencesPermission: boolean;

    accountSettings: IAccountSettingsContent;

    calendarDirection: CalendarDirection;

    private currentDateLoadingSubscription: Subscription | null = null;

    static $inject = ["$q", "$scope", "$state", "$timeout", "$interval", "webSocketService", "vehicleService", "driverAssignmentService", "journeyService", "plotService", "accountFeatureService", "cameraDisplayService", "sessionService", "navigationService", "translationService", "preferencesService", "veriDate", "displayService", "accountSettingsService"];

    constructor(
        private readonly $q: angular.IQService,
        private readonly $scope: angular.IScope,
        private readonly $state: StateService,
        private readonly $timeout: angular.ITimeoutService,
        private readonly $interval: angular.IIntervalService,
        private readonly webSocketService: WebSocketService,
        private readonly vehicleService: VehicleService,
        private readonly driverAssignmentService: DriverAssignmentService,
        private readonly journeyService: JourneyService,
        private readonly plotService: PlotService,
        private readonly accountFeatureService: AccountFeatureService,
        private readonly cameraDisplayService: CameraDisplayService,
        private readonly factSession: SessionService,
        private readonly navigationService: NavigationService,
        private readonly translationService: TranslationService,
        private readonly preferencesService: PreferencesService,
        private readonly veriDate: VeriDate,
        private readonly displayService: DisplayService,
        private readonly accountSettingsService: AccountSettingsService,

    ) {

        this.addLivemapTab(this.translationService.t("LiveMap.Live"), LiveMapPageStates.Live, () => false);

        if (this.accountFeatureService.currentUserHasRole([UserRole.History])) {
            this.addLivemapTab(this.translationService.t("LiveMap.History"), LiveMapPageStates.History, () => !this.selectedVehicle);
            this.addLivemapTab(this.translationService.t("LiveMap.Graphs"), LiveMapPageStates.Graph, () => !this.selectedVehicle);

            if (this.accountFeatureService.currentUserHasFeatureAccess(AccountFeatures.Camera)) {
                this.addLivemapTab(this.translationService.t("LiveMap.Video"), LiveMapPageStates.Video, () => !this.selectedVehicle || !this.selectedVehicle.hasCamera);
            }

            this.addLivemapTab(this.translationService.t("LiveMap.Timeline"), LiveMapPageStates.Timeline, () => !this.selectedVehicle);
        }


        if (this.accountFeatureService.currentUserHasRole([UserRole.ManageGeofences])) {
            this.canManageGeofencesPermission = true;
        }

        this.accountOptions = this.factSession.getItem<AccountOption>(SettingsName.AccountOptions);
    }

    $onInit() {
        this.loadUserPreferences().finally(() => {
            this.updateInputGraphs();
            this.initialise();
        });

        this.accountSettingsService.getAccountSettings().then(settings => {
            this.accountSettings = settings;
        });

        this.calendarDirection = CalendarDirection.TodayPast;
    }

    get accountSettingsShowLiveView(): boolean {
        return !this.accountSettings?.DisableLiveView?.Value;
    }

    get hasPopupContent(): boolean {
        return (
            !this.accountOptions?.Tms ||
            !!this.canManageGeofencesPermission ||
            !!this.timelineClickData?.geofenceVisit ||
            !!this.timelineClickData?.driverMapping ||
            !!this.timelineClickData?.trailerMapping
        );
    }

    private loadUserPreferences(): angular.IPromise<any> {
        return this.preferencesService.getUserPreferences().then(userPreferences => {
            this.showVehiclesNotTracking = !!userPreferences?.ShowVehiclesNotTracking?.Value;
        });
    }

    private showTab(tab: ILivemapTab | LiveMapPageStates, loadHistoryIfRequired = true) {
        if (typeof tab != "object") {
            tab = this.getTab(tab);
        }

        if (!tab) {
            console.error("No tab found");
            return;
        }

        if (this.selectedTab && this.selectedTab == tab) {
            return;
        }

        this.selectedTab = tab;

        const previousLiveStatus = this.showLiveView;

        this.showLiveView = false;
        this.showHistoryView = false;
        this.showGraphView = false;
        this.showVideoView = false;
        this.showLocationsView = false;
        this.showTimelineView = false;
        this.loadingBottomPanelContents = true;

        var heightAdjust = 0;

        switch (tab.tab) {
            default:
                this.showLiveView = true;
                this.bottomPanelHeight = 0;
                break;

            case LiveMapPageStates.History:
                this.showHistoryView = true;
                this.bottomPanelHeight = 80 + heightAdjust;
                break;

            case LiveMapPageStates.Graph:
                this.showGraphView = true;
                this.bottomPanelHeight = 450 + heightAdjust;
                this.getSensorsData();
                break;

            case LiveMapPageStates.Video:
                this.showVideoView = true;
                this.bottomPanelHeight = 450 + heightAdjust;
                break;

            //case LiveMapPageStates.Locations:
            //    this.showLocationsView = true;
            //    this.bottomPanelHeight = 275 + heightAdjust;
            //    break;

            case LiveMapPageStates.Timeline:
                this.showTimelineView = true;
                this.bottomPanelHeight = 370 + heightAdjust;
                break;
        }

        // Fleet History
        if (!this.selectedVehicle) {
            this.bottomPanelHeight = 0;
        }

        if (previousLiveStatus != this.showLiveView) {
            if (!this.showLiveView && loadHistoryIfRequired) {
                this.currentDateLoadingSubscription = this.loadHistoryForSelectedDay().subscribe();
            }
        }

        this.updatePageState();

        // Housekeeping
        this.videoPlaybackEvent = null;
        this.expectedVideoLocation = null;

        this.$timeout(() => {
            this.loadingBottomPanelContents = false;
        }, 600);
    }

    private getTab(label: string | LiveMapPageStates): ILivemapTab {
        return this.livemapTabs.find(tab => label === tab.tab || label == tab.label.toLowerCase());
    }

    onVideoMouseEvent(videoEntry: IVideoEntry, eventAction: EventAction) {
        var foundEvent: IPlotEvent = null;
        if (videoEntry) {
            this.historicalDay.journeyModel.journeys.forEach(journey => {
                journey.events.forEach(event => {
                    if (event.data && this.isEventVideoEvent(event) && event.data.Id === videoEntry.Id) {
                        foundEvent = event;
                    }
                });
            });
        }

        if (!foundEvent) {
            this.onHistoricalMouseEvent(null, foundEvent, null, eventAction);
        }
        else {
            this.$timeout(() => {
                this.onHistoricalMouseEvent(null, foundEvent, null, eventAction);
            }, 0);
        }
    }

    onShowPopup(position: google.maps.LatLng, model: any) {
        this.popupPosition = position;
        this.popupModel = model;
    }

    onPlotRightClick($event: IPlot) {
        var latLng = new google.maps.LatLng($event.Latitude, $event.Longitude);
        this.veriMap.hidePopup(MapPopupType.Geofence, true);
        this.veriMap.showPopup(MapPopupType.RightClick, latLng, $event);
    }

    onHistoricalMouseEvent(journey: IJourney, event: IPlotEvent, plot: IPlot, eventAction: EventAction) {
        // Click again to deselect logic
        if (this.selectedJourney && journey && this.selectedJourney.Id === journey.Id) {
            journey = null;
        }

        if (this.selectedPlotEvent && event && this.selectedPlotEvent.id === event.id) {
            event = null;
        }

        if (this.selectedPlot && plot && this.selectedPlot.Id === plot.Id) {
            plot = null;
        }

        if (eventAction === EventAction.Selected) {
            this.selectedJourney = journey;
            this.selectedPlot = plot;

            this.selectPlotEvent(event);
            this.plotHighlighted(plot);
            this.highlightPlotEvent(event);

            if (plot) {
                this.requestVideoTime = plot.UtcMoment;
            }
            else if (event && !this.isEventVideoEvent(event)) {
                this.requestVideoTime = moment(event.Utc);
            }
            else {
                this.requestVideoTime = null;
            }
        }
        else if (eventAction === EventAction.Hover) {
            this.highlightedJourney = journey;
            this.plotHighlighted(plot || this.selectedPlot);
            this.highlightPlotEvent(event || this.selectedPlotEvent);
        }
        else {
            console.error("onHistoricalMouseEvent - Unknown event");
        }
    }

    plotHighlighted(plot: IPlot) {

        this.highlightedPlot = plot;

        for (var i = 0; i < this.plots.length; i++) {
            var plot = this.displayPlots[i];

            if (this.highlightedPlot && plot.Id === this.highlightedPlot.Id) {
                this.highlightedPlotIndex = i;
                break;
            }
        }
    }

    onHistoricalViewChanged(viewState: VehicleHistoryPage) {
        this.vehicleHistoryPage = viewState;
    }


    onPlotsFiltered(plots: IPlot[]) {
        this.displayPlots = plots;
    }

    goToMessagesPage() {
        this.navigationService.goToMessagesPage(this.selectedVehicle);
    }

    goToTmsPage() {
        this.navigationService.goToTMSPage(this.selectedVehicle);
    }

    goToPlanningPage() {
        this.navigationService.goToPlanningPage(this.selectedVehicle);
    }

    closePopups() {
        this.veriMap.hidePopup(MapPopupType.RightClick, true);
        this.veriMap.hidePopup(MapPopupType.Custom, true);
    }

    private highlightPlotEvent(event: IPlotEvent) {
        this.highlightedPlotEvent = event;
        if (event && event.plot) {
            this.highlightedPlot = event.plot;
        }
    };

    private selectPlotEvent(event: IPlotEvent) {
        this.selectedPlotEvent = event;

        if (event && event.plot) {
            this.selectedPlot = event.plot;
        }

        if (this.isEventVideoEvent(event)) {
            this.showTab(LiveMapPageStates.Video);
        }
    }

    private isEventVideoEvent(event: IPlotEvent): boolean {
        if (event == null || event.data == null) {
            return false;
        }

        return (event.data as IVideoEntry).Status !== undefined;
    }

    private addLivemapTab(tabLabel: string, tab: LiveMapPageStates, disabledFunc: () => boolean) {
        this.livemapTabs.push({
            label: tabLabel,
            tab: tab,
            urlSlug: LiveMapPageStates[tab].toLowerCase(),
            disabled: disabledFunc(),
            disabledFunc: disabledFunc,
        });
    }

    private updateTabDisabledStatus() {
        this.livemapTabs.forEach(tab => {
            tab.disabled = tab.disabledFunc();
        });
    }

    private initialise(): void {
        this.startUpdates(true);

        this.setupSocketStreaming();

        this.$scope.$on("$destroy", () => {
            this.destroy();
        });

        this.$scope.$on(BroadcastEvent.onPageVisibilityHide, () => {
            this.stopUpdates();
        });

        this.$scope.$on(BroadcastEvent.onPageVisibilityShow, () => {
            this.startUpdates(false);
        });
    }

    private startUpdates(firstRun: boolean) {
        // Update every minute
        this.vehicleUpdateInterval = this.$interval(() => {

            // If we havent received an update for a minute then do a standard poll
            var secondsSinceLastUpdate = moment().diff(this.lastScreenRefreshTime, "s");

            if (secondsSinceLastUpdate >= 60) {
                this.updateData(false);
            }
            // Add a seconds grace to ensure we update correctly
            else if (this.latestPlotUpdateTime && this.latestPlotUpdateTime.isAfter(this.lastScreenRefreshTime)) {
                this.updateVehicleList(this.vehicles);
            }
        }, 10 * 1000);

        this.updateData(firstRun);
    }

    private stopUpdates() {
        if (this.vehicleUpdateInterval) {
            this.$interval.cancel(this.vehicleUpdateInterval);
        }
    }

    private destroy() {
        this.stopUpdates();

        this.webSocketService.unregisterListener("PlotDataStream");
    }

    mapIdle(veriMap: IVeriMapComponent) {
        this.veriMap = veriMap;

        this.nearestToCenter = veriMap.getMapOffsetCenter();
    }

    onGeofenceClicked(geofence: IGeofence) {
        const latLng = new google.maps.LatLng(geofence.Latitude, geofence.Longitude);
        this.veriMap.smoothPanAndZoomTo(latLng, 15).finally(() => {
            this.veriMap.showPopup(MapPopupType.Geofence, latLng, geofence, true);
        });
    }

    onTimelineClicked(timelineObj: ITimelineClickData) {
        var latLng = new google.maps.LatLng(timelineObj.lat, timelineObj.lng);
        this.timelineClickData = timelineObj;

        this.veriMap.smoothPanAndZoomTo(latLng, 16).finally(() => {
            this.veriMap.showPopup(MapPopupType.Custom, latLng, null);
        });
    }


    changeToSelectedVehicle(trailerMapping: IVehicleTrailerMapping) {
        this.showTab(LiveMapPageStates.History);
    }

    updateDriverHistory(driverMapping: IVehicleDriverMapping) {
        this.selectedPlotDate = driverMapping.StartUtc.toDate();

        this.loadHistoryForSelectedDay();
    }

    setSelectedVehicle(vehicle: IVehicle, updatePageState: boolean = true): void {
        if (this.selectedVehicle === vehicle || (vehicle != null && this.selectedVehicle != null && this.selectedVehicle.Id === vehicle.Id)) {
            vehicle = null;
        }

        this.currentJourney = null;
        if (vehicle) {
            if (vehicle.tractor) {
                this.getCurrentJourney(vehicle.tractor.Id);
            }
            else {
                this.getCurrentJourney(vehicle.Id);
            }
            this.selectedVehicle = vehicle;
            this.getSensorsData();
            
            if (this.currentDateLoadingSubscription) {
                this.currentDateLoadingSubscription.unsubscribe();
                this.currentDateLoadingSubscription = null;
            }

            this.currentDateLoadingSubscription = this.loadHistoryForSelectedDay().subscribe();
        }
        else {
            // If the vehicle has been deselected, reset the view state
            this.closePlotsView(true);
        }

        this.updateTabDisabledStatus();

        this.requestVideoTime = null;

        if (updatePageState) {
            this.updatePageState();
        }
    }

    showRequestVideoDialog(requestTime: moment.Moment, $event: MouseEvent) {

        this.navigationService.go(`${FleetNavigationModule.Vehicles}.view`, { vehicleId: this.selectedVehicle.Id, tab: 'requestVideo', requestVideoTime: requestTime.toDate() })
    }

    closePlotsView(fitMap: boolean) {
        this.clearMap();

        this.selectedPlot = null;
        this.selectedVehicle = null;

        this.showTab(LiveMapPageStates.Live);

        //this.veriMap.fitMapToAll();
        this.updateTabDisabledStatus();
    }

    selectJourney(journey: IJourney, fitmap = true) {

        if (journey && this.selectedJourney && journey.Id === this.selectedJourney.Id) {
            journey = null;
        }

        this.resetHistoryMarkers();

        this.selectedJourney = journey;
        this.fitMap = true;

        if (this.selectedJourney) {
            this.historicalDriverTime = moment(this.selectedJourney.StartUtc);
        }
        else if (this.journeyModel && this.journeyModel.journeys.length > 0) {
            this.historicalDriverTime = moment(this.journeyModel.journeys[0].StartUtc);
        }
    }

    highlightJourney(journey: IJourney) {
        this.highlightedJourney = journey;
    }

    updateJourneyPlot(plotPoint: IPlot, mouseXPos: number) {
        this.plotHighlighted(plotPoint);
    }

    onExtremesUpdated(extremes: IJourneyGraphExtremes) {
        this.journeyExtremes = angular.copy(extremes);
    }

    setDisplayVehicles(vehicles: IVehicle[]) {
        this.vehiclesDisplay = [];

        for (var i = 0; i < vehicles.length; i++) {
            const vehicle = vehicles[i];

            if (this.showVehiclesNotTracking || vehicle.Plot) {
                this.vehiclesDisplay.push(vehicle);
            }
        }

        if (!this.vehiclesDisplay.find(v => v == this.selectedVehicle)) {
            this.selectedVehicle = null;
            this.updateTabDisabledStatus();
            this.showTab(LiveMapPageStates.Live);
        }
    }

    vehicleClicked(vehicle: IVehicle, fitMap?: boolean): void {
        this.setSelectedVehicle(vehicle);
    }

    vehicleDoubleClicked(vehicle: IVehicle): void {
        this.setSelectedVehicle(vehicle);
    }

    vehicleRightClicked(vehicleMarker: IGoogleMapsMarker<IVehicle>): void {
        if (!vehicleMarker.model.Plot) {
            return;
        }

        var latLng = new google.maps.LatLng(vehicleMarker.model.Plot.Latitude, vehicleMarker.model.Plot.Longitude);
        this.veriMap.hidePopup(MapPopupType.Geofence, true);
        this.veriMap.showPopup(MapPopupType.RightClick, latLng, vehicleMarker.model);
    }

    vehicleMouseOver(vehicle: IVehicle, event: Event): void {
        this.utilisationMetrics = null;

        this.veriMap.showPopup(MapPopupType.Vehicle, new google.maps.LatLng(vehicle.Plot.Latitude, vehicle.Plot.Longitude), vehicle);
    }

    vehicleMouseOut(vehicle: IVehicle): void {
        this.utilisationMetrics = null;
        this.veriMap.hidePopup(MapPopupType.Vehicle, true);
    }

    clusterMouseOver(ngMapCluster: NgMapCluster, metrics: IUtilisationMetrics): void {
        this.utilisationMetrics = metrics;
    }

    clusterMouseOut(ngMapCluster: NgMapCluster, metrics: IUtilisationMetrics): void {
        this.utilisationMetrics = null;
    }

    addGeofenceAtPosition(position: google.maps.LatLng, resource: IVehicle | IPlot) {
        this.closePopups();
        this.$scope.$broadcast(BroadcastEvent.openGeofenceEditor, null, position, resource);
    }

 showLiveVideoTab(): void {
        this.showTab(LiveMapPageStates.Video);
    }

    // Todo: Remove
    plotClicked(plot: IPlot, panToPlotPoint: boolean = true, panPlotList: boolean = true): void {
        if (!plot || plot.Direction == null) {
            // Sanity check against scopes being passed in which can occur in rare UI events
            return;
        }

        this.onPlotSelected(plot, panPlotList);
        this.updateJourneyPlot(plot, -1);

        this.plotService.setPlotSelectedClass(plot, true);

        // TOdo: check if this is required?
        if (/*this.showPlotsView && */panToPlotPoint) {
            this.veriMap.fitMap([new google.maps.LatLng(plot.Latitude, plot.Longitude)]);
        }
    }

    onPlotSelected(plot: IPlot, panPlotList = false) {
        this.selectedPlot = plot;

        if (plot) {
            this.historicalDriverTime = this.selectedPlot.UtcMoment;
        }

        this.setHighlightedPlot(plot);

    }

    onPlotHighlighted(plot: IPlot, highlight: boolean = true) {
        this.setHighlightedPlot(plot, highlight);
    }

    // Todo: Remove?
    setHighlightedPlot(plot: IPlot, highlight: boolean = true) {
        if (highlight) {
            this.highlightedPlot = plot;
        }
        else if (this.selectedPlot !== null) {
            this.highlightedPlot = this.selectedPlot;
        }

        if (this.highlightedPlot) {
            this.highlightedVehicle = this.selectedVehicle;
        }

        for (var i = 0; i < this.displayPlots.length; i++) {
            var plot = this.displayPlots[i];

            if (this.highlightedPlot && plot.Id == this.highlightedPlot.Id) {
                this.highlightedPlotIndex = i;
                break;
            }
        }
    }

    clearMap(): void {
        this.resetHistoryMarkers();

        this.videoPlaybackEvent = null;
        this.plots = [];
        //this.filterDisplayPlots();

        //this.journeyPlot = null;
        this.journeyEvents = [];
    }

    showLocations(location: any): void {
        location.ShowPlotLocations = !location.ShowPlotLocations;
    }

    updateVehicleList(vehicles: IVehicle[]) {
        vehicles.forEach(vehicle => {
            const existingVehicleIndex = this.vehicles.findIndex(x => x.Id === vehicle.Id);

            if (existingVehicleIndex >= 0) {
                this.vehicles[existingVehicleIndex] = vehicle;
            } else {
                this.vehicles.push(vehicle);
            }
        });

        if (this.selectedVehicle) {
            const refreshedSelectedVehicle = this.vehicles.find(x => x.Id === this.selectedVehicle.Id)

            if (refreshedSelectedVehicle) {
                this.selectedVehicle = refreshedSelectedVehicle;

                if (this.showLiveView) {
                    this.selectedPlot = refreshedSelectedVehicle.Plot;
                }
            }
        }

        this.lastScreenRefreshTime = this.veriDate.createMoment(new Date());

        // For some reason needs that to update view, $scope.$digest and .$applyAsync not working...
        this.vehicles = [...this.vehicles];
        this.vehiclesDisplay = [...this.vehiclesDisplay];
    }

    onHistoricalDateChanged(date: Date) {
        this.selectedPlotDate = date || new Date();

        // Cancel in-progress event changes
        if (this.currentDateLoadingSubscription) {
            this.currentDateLoadingSubscription.unsubscribe();
            this.currentDateLoadingSubscription = null;
        }

        this.currentDateLoadingSubscription = this.loadHistoryForSelectedDay().subscribe();
        this.updateInputGraphs();
    }

    loadHistoryForSelectedDay(): Observable<IHistoricalDay | null> {
        this.clearMap();
        this.journeyModel = null;
        this.journeyEvents = [];

        if (!this.accountFeatureService.currentUserHasRole([UserRole.History])) {
            return of(null);
        }

        this.loadingHistory = true;
        const dateToLoad = new Date(this.selectedPlotDate);
        const selectedDateIsToday = moment(this.selectedPlotDate).isSame(moment(), "d");

        //(this.$scope as any).$suspend();

        this.updatePageState();

        // Get the correct data for events

        // Note for ease we load everything when the history panel is selected

        // convert $q promise to observable
        return new Observable<IHistoricalDay>(observer => {
            this.journeyService.getAllJourneyDataForVehicle(this.selectedVehicle, this.selectedPlotDate, selectedDateIsToday)
                .then(
                    (historicalDay: IHistoricalDay) => {
                        if (this.selectedPlotDate.getTime() === dateToLoad.getTime()) {
                            observer.next(historicalDay);
                        } else {
                        }
                        observer.complete();
                    },
                    (error) => {
                        observer.error(error);
                    }
                );
        }).pipe(
            tap((historicalDay: IHistoricalDay) => {
                if (this.selectedPlotDate.getTime() !== dateToLoad.getTime()) {
                    return;
                }

                this.historicalDay = historicalDay;
                this.journeyModel = historicalDay.journeyModel;
                this.selectedVehicle.hasTemperature = true;
                this.plots = historicalDay.plots;
                this.displayPlots = this.plots;

                if (this.journeyModel?.journeys) {
                    this.journeyModel.journeys.forEach((journey) => {
                        this.journeyEvents.push.apply(this.journeyEvents, journey.events);
                    });

                    if (this.journeyModel.journeys.length > 0) {
                        this.historicalDriverTime = moment(this.journeyModel.journeys[0].StartUtc);
                    } else {
                        this.historicalDriverTime = moment(this.selectedPlotDate);
                    }
                }

                this.fitMap = true;
            }),
            catchError(err => {
                console.error('Error caught in pipe:', err);
                return of(null);
            }),
            finalize(() => {
                this.loadingHistory = false;

                if (this.currentDateLoadingSubscription &&
                    this.selectedPlotDate.getTime() === dateToLoad.getTime()) {
                    this.currentDateLoadingSubscription = null;
                }
            })
        );
    }

    videoPlaybackEvent: IVideoPlaybackEvent;

    onVideoPlaybackEvent(videoPlaybackEvent: IVideoPlaybackEvent) {
        if (videoPlaybackEvent &&
            videoPlaybackEvent.currentGpsData &&
            videoPlaybackEvent.currentGpsData.Latitude !== 0 &&
            videoPlaybackEvent.currentGpsData.Longitude !== 0) {
            this.videoPlaybackEvent = videoPlaybackEvent;
        }
        else {
            this.videoPlaybackEvent = null;
        }
    }

    onVehicleGanttMouseMove(time: moment.Moment) {
        const matchingPlot = this.plotService.findMatchingPlot(time, time, this.plots);

        this.onHistoricalMouseEvent(this.highlightedJourney, null, matchingPlot, EventAction.Hover);
    }

    onJourneyExtremesChange(extremes: IJourneyGraphExtremes) {
        this.journeyExtremes = extremes;
    }

    vehicleOrderbyChanged($orderBy: LiveMapOrderByOptions) {
        this.showMapCross = $orderBy === LiveMapOrderByOptions.Distance;
    }

    // ---------------------------------------

    private updateInputGraphs() {
        this.start = moment(this.selectedPlotDate).startOf("d").toDate();
        this.end = moment(this.selectedPlotDate).endOf("d").toDate();
    }

    private setupSocketStreaming() {

        //this.webSocketService.registerListener<IPlot>("PlotDataStream" as any, (plot) => {
        //    this.updateVehiclePlot(plot);

        //    if (plot && plot.UtcMoment && plot.UtcMoment.isAfter(this.latestPlotUpdateTime)) {
        //        this.latestPlotUpdateTime = plot.UtcMoment;
        //    }
        //});
    }

    private updateVehiclePlot(plot: IPlot) {
        const v = this.vehicleService.findVehicle(this.vehicles, plot.VehicleId);

        if (!v) {
            return;
        }

        v.Plot = plot;
        this.plotService.preparePlotForMap(v.Plot);

        return;
    }

    private updatePageState() {
        const selectedDateIsToday = moment(this.selectedPlotDate).isSame(moment(), "d");

        const routeParams = {
            "panel": "live",
            "date": selectedDateIsToday ? "today" : moment(this.selectedPlotDate).format("YYYY-MM-DD"),
            "vehicle": ""
        };

        if (this.selectedTab) {
            routeParams["panel"] = this.selectedTab.urlSlug;
        }

        if (this.showLiveView) {
            routeParams["date"] = "";
        }

        if (this.selectedVehicle) {
            const sanitizedReg = this.vehicleService.getSanitizedReg(this.selectedVehicle);

            routeParams["vehicle"] = sanitizedReg;
        }

        this.$state.go(this.$state.current.name, routeParams, { location: true, notify: false, reload: false });

        this.$state.current.params["subTitle"] = this.selectedVehicle?.ShortReg || "Vehicles";
    }

    private preselectPageState() {
        let vehicle: IVehicle = null;

        if (this.$state.params["vehicle"]) {
            vehicle = this.vehicleService.findVehicleByReg(this.vehicles, this.$state.params["vehicle"]);

            // only load history if we have a vehicle
            if (vehicle) {
                this.$timeout(() => {
                    this.setSelectedVehicle(vehicle, false);

                    if (this.currentDateLoadingSubscription) {
                        this.currentDateLoadingSubscription.unsubscribe();
                        this.currentDateLoadingSubscription = null;
                    }

                    this.currentDateLoadingSubscription = this.loadHistoryForSelectedDay().subscribe();

                    if (this.$state.params["panel"]) {
                        this.showTab(this.$state.params["panel"], false);
                    }

                    const dateComponent = this.$state.params["date"];
                    if (dateComponent && dateComponent !== "today") {
                        const date = moment(dateComponent, "YYYY-MM-DD");
                        this.selectedPlotDate = date.toDate();

                        // cancel existing subscription before loading with new date
                        if (this.currentDateLoadingSubscription) {
                            this.currentDateLoadingSubscription.unsubscribe();
                            this.currentDateLoadingSubscription = null;
                        }

                        // new subscription with the new date
                        this.currentDateLoadingSubscription = this.loadHistoryForSelectedDay().subscribe();
                    }
                }, 500);
            } else {
                this.showTab(LiveMapPageStates.Live);
            }
        } else {
            this.showTab(LiveMapPageStates.Live);
        }
    }

    private updateData(firstRun): angular.IPromise<any> {

        //(this.$scope as any).$suspend();

        return this.driverAssignmentService
            .getVehiclesWithDrivers({
                includeLatestPlots: true,
                includeTrailerMappings: true,
                includeProbes: true,
                includePeripheralMappings: true,
                invalidateCache: true
            })
            .then(vehicles => {

                this.updateVehicleList(vehicles);

                if (this.selectedVehicle && this.showLiveView) {
                    // Update current journey with new plot
                    if (this.currentJourney && this.selectedVehicle.Plot) {
                        this.currentJourney.EndUtc = this.selectedVehicle.Plot.Utc;
                    }
                }

                if (firstRun) {
                    this.preselectPageState();
                }

                for (var i = 0; i < this.vehicles.length; i++) {
                    const vehicle = this.vehicles[i];

                    if (vehicle.Plot && (!this.latestPlotUpdateTime || this.latestPlotUpdateTime < vehicle.Plot.UtcMoment)) {

                        // Ensure we dont go into the future [it happens]
                        if (vehicle.Plot.UtcMoment.isBefore(moment())) {
                            this.latestPlotUpdateTime = vehicle.Plot.UtcMoment;
                        }
                    }
                }
            })
            .catch((e) => {
                console.error("Error", e);
            })
            .finally(() => {
                //(this.$scope as any).$resume();
                this.initialLoading = false;
            });

    }

    private getCurrentJourney(vehicleId: number): angular.IPromise<IJourney> {
        if (!this.accountFeatureService.currentUserHasRole([UserRole.History])) {
            return this.$q.resolve(null);
        }

        return this.journeyService
            .getCurrentJourney(vehicleId)
            .then(journey => {
                this.currentJourney = journey;

                return journey;
            })
            .catch(() => {
                // This prevents the webpage simply refreshing
                this.currentJourney = null;
                return null;
            });
    }



    private resetHistoryMarkers() {
        this.selectedJourney = null;
        this.selectedPlot = null;
        //this.journeyPlot = null;
    }

    private getSensorsData() {
        this.loadingHistory = true;
        this.journeyService.getSensorsDataForVehicle(this.selectedVehicle, this.selectedPlotDate)
            .then(sensorsData => {
                this.journeyService.attachSensorDataToPlots(this.plots, sensorsData)
            })
            .finally(() => { this.loadingHistory = false });
    }
}
